import { useContext } from 'react';

import { ThemeContext } from '../../contexts/theme';
import './Footer.css';

/* ------------------------- component ------------------------- */
const Footer = () => {
  const [{ themeName }] = useContext(ThemeContext);

  /* ------------------------- render ------------------------- */
  return (
    <footer className='footer'>
      <a
        href='https://github.com/acsnevesgit/acsneves-portfolio'
        target="_blank"
        rel="noopener noreferrer"
        className='link footer-link'
      >
        Created with<span>{' '}{themeName === 'dark' ? '🤍' : '🖤'}{' '}</span>by acsneves
      </a>
    </footer>
  )
};

export default Footer;
